/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Chart/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Chart({
  children,
  viewPath = "/DesignSystem/Report/ReportTable/Done/Content/Chart"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let reportTableChartValueData = fromData.useDataValue({ viewPath,
context: 'report_table',
path: 'chart',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(reportTableChartValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}